import { Toaster } from "react-hot-toast";
import './App.scss'
import RoutesApp from "./routes";

function App() {
    return (
        <div className="App">
            <div>
                <Toaster
                    position="top-center"
                    reverseOrder={true}
                />
            </div>
            <div className={"container-app"}>
                <RoutesApp/>
            </div>
        </div>
    );
}

export default App;
